import {
    SET_MESSAGES,
    ADD_TOAST,
    ADD_ERROR,
    ADD_WARNING,
    ADD_SUCCESS,
    ADD_INFO,
    ADD_MESSAGE,
    REMOVE_TOAST,
    REMOVE_TOASTS,
    RESHOW_NEWEST_MOTD,
    MOTDS_CHANGED,
    // SEVERITY_ERROR,
    // SEVERITY_WARNING,
    // SEVERITY_SUCCESS,
    // SEVERITY_INFO,
} from './constants'
import { createToast } from './api'
import { getActiveQueue } from '../../selectors'

export function setMessages(motds) {
    return {
        type: SET_MESSAGES,
        payload: {
            messages: motds,
            options: createToast({}),
        },
    }
}

export function addToast(options = {}) {
    return (dispatch, getState) => {
        const queue = getActiveQueue(getState()).name
        dispatch({
            type: ADD_TOAST,
            payload: createToast(options, queue),
        })
    }
}

export function addError(options = {}) {
    return (dispatch, getState) => {
        const queue = getActiveQueue(getState()).name
        dispatch({
            type: ADD_ERROR,
            payload: createToast(options, queue),
        })
    }
}

export function addWarning(options = {}) {
    return (dispatch, getState) => {
        const queue = getActiveQueue(getState()).name
        dispatch({
            type: ADD_WARNING,
            payload: createToast(options, queue),
        })
    }
}

export function addSuccess(options = {}) {
    return (dispatch, getState) => {
        const queue = getActiveQueue(getState()).name
        dispatch({
            type: ADD_SUCCESS,
            payload: createToast(options, queue),
        })
    }
}

export function addInfo(options = {}) {
    return (dispatch, getState) => {
        const queue = getActiveQueue(getState()).name
        dispatch({
            type: ADD_INFO,
            payload: createToast(options, queue),
        })
    }
}

export function addMessage(message, options = {}) {
    return {
        type: ADD_MESSAGE,
        payload: {
            options: createToast(options),
            message,
        },
    }
}

export function removeToast(id) {
    return {
        type: REMOVE_TOAST,
        payload: { id, dismissed: +new Date() },
    }
}

export function removeToasts(ids) {
    return {
        type: REMOVE_TOASTS,
        payload: { ids, dismissed: +new Date() },
    }
}

export function reshowNewestMotd() {
    return {
        type: RESHOW_NEWEST_MOTD,
    }
}

export function motdsChanged(motds) {
    return {
        type: MOTDS_CHANGED,
        payload: motds,
    }
}



// WEBPACK FOOTER //
// ./src/features/Toaster/data/toasts/actions.js